module.exports = __webpack_public_path__ + "static/media/gallaxy-background-available-art-page.eff59fe6.jpg";